import { isCustomView } from './is-custom-view';
import { isObject } from '../is-object';
export function isSetterConfig(obj) {
  if (!isObject(obj)) {
    return false;
  }
  return 'componentName' in obj && !isCustomView(obj);
}